import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  TaxGroupNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { TaxGroup as TaxGroupEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";
import TaxGroupModel from "../../data/model/TaxGroup";

const taxGroupQuery = gql`
${TaxGroupNoNestingFragment}
${PaginatedListMetaNoNestingFragment}
query GetTaxGroups(${listVariables}) {
    taxGroups(${listOptions}) {
        items {
          ...TaxGroupNoNesting
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const taxGroupDefinition = new EntityResourceDefinition<
  TaxGroupEntity,
  TaxGroupModel
>({
  entity: "tax_groups",
  query: taxGroupQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.name = fetchedEntity?.name || "";
    newEntity.shortName = fetchedEntity.shortName ?? "";
    newEntity.arrivalPercentage = fetchedEntity.arrivePercentage ?? 0;
    newEntity.salePercentage = fetchedEntity.salePercentage ?? 0;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "taxGroups", taxGroupQuery, options);
  },
});
